import { Collapsible as BaseCollapsible } from '@base-ui/react/collapsible';
import type { ComponentProps } from 'react';
import { cx, styled } from '../lib/styled.tsx';

/** See {@link Accordion}'s panel for why the padding sits on an inner element. */
function CollapsiblePanel({
  children,
  className,
  ...props
}: ComponentProps<typeof BaseCollapsible.Panel>) {
  return (
    <BaseCollapsible.Panel
      className={cx(
        'h-[var(--collapsible-panel-height)] overflow-hidden',
        'transition-[height] duration-200 ease-out-quint',
        'data-starting-style:h-0 data-ending-style:h-0',
        className,
      )}
      {...props}
    >
      <div className="pt-2 text-sm text-ink-muted">{children}</div>
    </BaseCollapsible.Panel>
  );
}

/**
 * One panel that shows and hides. {@link Accordion} is the same mechanism for a
 * set of panels that know about each other; this is the standalone case.
 */
export const Collapsible = {
  Root: styled(BaseCollapsible.Root, 'flex w-full flex-col'),
  Trigger: styled(
    BaseCollapsible.Trigger,
    'inline-flex w-fit items-center gap-2 text-sm font-medium text-ink outline-none ' +
      'hover:not-data-disabled:text-brand-600 ' +
      'data-disabled:cursor-not-allowed data-disabled:opacity-50',
  ),
  Panel: CollapsiblePanel,
};
